type PageQuery = {
    o?: string;
};

export const isFirstPage = (queryParams: PageQuery): boolean => !queryParams.o || queryParams.o === '0';
